import { Component, computed, input } from '@angular/core';

export type StatusBadgeVariant = 'published' | 'draft' | 'danger';

@Component({
  selector: 'app-status-badge',
  standalone: true,
  template: `<span [class]="klass()"><ng-content /></span>`,
})
export class StatusBadgeComponent {
  readonly variant = input<StatusBadgeVariant>('draft');

  readonly klass = computed(() => {
    const v = this.variant();
    return `cg-admin-status-badge cg-admin-status-badge--${v}`;
  });
}
